import moment from "moment-timezone";
export const redirectUri = `${window.origin + "/auth-login-with-sf-callback"}`;

export function formatNumber(
  numberValue: number,
  minFractionDigits = 2,
  maximumFractionDigits = 2
) {
  if (numberValue) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: minFractionDigits,
      maximumFractionDigits: maximumFractionDigits
    }).format(numberValue);
  } else return "0";
}

export function maskAccountName(name: string) {
  if (!name) return "";
  const words = name.split(" ");
  const masked = words.map((word, index) => {
    // Special handling for first word if it's 2 or 3 letters
    if (index === 0 && (word.length === 2 || word.length === 3)) {
      return word[0] + "*".repeat(word.length - 1);
    }
    if (word.length <= 2) return "*".repeat(word.length);
    if (words.length === 1) {
      return word[0] + "*".repeat(word.length - 1);
    }
    if (index === 0) {
      return word[0] + "*".repeat(word.length - 1);
    } else if (index === words.length - 1) {
      return "*".repeat(word.length - 3) + word.slice(-3);
    } else {
      return "*".repeat(word.length);
    }
  });

  return masked.join(" ");
}

export function formatPhoneNumber(phoneNumber: any) {
  const cleaned = phoneNumber.toString().replace(/\D/g, ""); // Remove any non-digit characters
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/); // Match groups of 3, 3, and 4 digits

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return null; // Return null if the input is not a valid 10-digit number
}

export function cleanPhoneNumber(phoneNumber: any) {
  return phoneNumber.replace(/[^0-9]/g, "");
}
export function labelFunction(sort: any, order: any) {
  switch (sort) {
    case "updatedAt":
      return order === "ASC"
        ? "Property Added Oldest"
        : "Property Added Newest";
    case "askingPrice":
      return order === "ASC"
        ? "By Price Lowest To Highest"
        : "By Price Highest To Lowest";
    case "yearBuilt":
      return order === "ASC"
        ? "Year Build Lowest To Highest"
        : "Year Build Highest To Lowest";
    case "sqft":
      return order === "ASC"
        ? "Square Feet Lowest To Highest"
        : "Square Feet Highest To Lowest";
    default:
      return "Property Added Newest";
  }
}
export function numberWithCommas(x: any) {
  if (!x) return;
  return x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}
export const formatAbbreviatedCurrency = (
  amount: number | 0,
  locale: string
) => {
  let formattedAmount = "";

  if (amount >= 1_000_000) {
    formattedAmount = `${(amount / 1_000_000).toFixed(1)}M`;
  } else if (amount >= 1_000) {
    formattedAmount = `${(amount / 1_000).toFixed(0)}K`;
  } else {
    formattedAmount = amount?.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  return `$${formattedAmount}`;
};

export const formatAbbreviatedCurrencyWithoutSymbol = (
  amount: number | 0,
  locale: string
) => {
  let formattedAmount = "";

  if (amount >= 1_000_000) {
    formattedAmount = `${(amount / 1_000_000).toFixed(1)}M`;
  } else if (amount >= 1_000) {
    formattedAmount = `${(amount / 1_000).toFixed(0)}K`;
  } else {
    formattedAmount = amount?.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  return `${formattedAmount}`;
};

export function formatCurrency(
  currencyValue: number,
  currency = "USD",
  locale = "en-US",
  minFractionDigits = 0,
  maxFractionDigits = 0
) {
  if (currencyValue) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: minFractionDigits,
      maximumFractionDigits: maxFractionDigits
    }).format(currencyValue);
  } else return;
}

export const dateFormat = (getDate: any, format: string) => {
  const getDateFormat = moment(getDate).format(format);
  return getDateFormat;
};

export const pstDateFormat = (getDate: any) => {
  const getDateFormat = moment(getDate).format("MMMM D, YYYY");
  return getDateFormat;
};

export const dateAndTimeFormat = (getDate: any) => {
  const getDateFormat = moment(getDate).format("MMMM D, YYYY h:mm A");
  return getDateFormat;
};

export const dateMonthFormat = (getDate: any) => {
  const getDateFormat = moment(getDate).format("MMM D, YYYY");
  return getDateFormat;
};

export const monthFormate = (getDate: any) => {
  const getDateFormat = moment(getDate).format("MMMM Do, YYYY");
  return getDateFormat;
};

export const dateMonthFormatForAccountDetails = (getDate: any) => {
  const getDateFormat = moment(getDate).format("DD MMM, YYYY");
  return getDateFormat;
};

export const isMobileBidsData = (objPropertyDetails: any) => {
  const {
    showingDateAndTime,
    bsEscrowCompany,
    offerDueDateAndTime,
    closeDate,
    bsDeposit
  } = objPropertyDetails || {};
  const bidsData =
    showingDateAndTime ||
    bsEscrowCompany ||
    offerDueDateAndTime ||
    closeDate ||
    bsDeposit;

  return bidsData;
};

const DASHBOARD_PANELS = {
  RECENT_PROPERTIES: 0,
  BIDS: 1,
  SAVED_PROPERTIES: 2,
  PROPERTIES_LISTING: 3
};

export const getDashboardNotFoundMessage = (panelIndex: any) => {
  let notFoundData;

  switch (panelIndex) {
    case DASHBOARD_PANELS.RECENT_PROPERTIES:
      notFoundData = {
        title: "No recent properties found!",
        subTitle:
          "It looks like there are currently no recent properties available.",
        panelName: "Recent Properties",
        imageUrl: "/images/no-data-found.svg"
      };
      break;

    case DASHBOARD_PANELS.BIDS:
      notFoundData = {
        title: "No bids available!",
        subTitle:
          "Unfortunately, there are no bids at this moment. Please check again later after placing bids.",
        panelName: "Bids",
        imageUrl: "/images/no-data-found.svg"
      };
      break;

    case DASHBOARD_PANELS.SAVED_PROPERTIES:
      notFoundData = {
        title: "You have no saved properties!",
        subTitle:
          "It seems you have no saved any properties yet. Please check again later after saving properties.",
        panelName: "Saved Properties",
        imageUrl: "/images/no-data-found.svg"
      };
      break;

    case DASHBOARD_PANELS.PROPERTIES_LISTING:
      notFoundData = {
        title: "No properties found!",
        subTitle: "It looks like there are currently no properties available.",
        panelName: "Properties Listing",
        imageUrl: "/images/no-data-found.svg"
      };
      break;

    default:
      notFoundData = "Invalid dashboard";
  }

  return notFoundData;
};

export function StatusObjectColorFilter(status: string) {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj ? JSON.parse(userObj) : {};
  const property_status = userDetail?.config?.filters
    ?.filter((item: any) => item?.type === "property_status")?.[0]
    .values?.filter((item: any) => item.value === status);
  return property_status?.[0];
}

export const latVar = {
  lat: 35.43693412954386,
  lng: -118.83968433172316,
  zoom: 4.497355254216229
};

export function countDaysFromDate(utcDateString: string): number {
  const givenDate = new Date(utcDateString); // parse the input date
  const today = new Date();

  // Convert both dates to UTC midnight (to ignore time part)
  const utcGiven = Date.UTC(givenDate.getUTCFullYear(), givenDate.getUTCMonth(), givenDate.getUTCDate());
  const utcToday = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());

  const msPerDay = 1000 * 60 * 60 * 24;
  const diffInDays = Math.floor((utcToday - utcGiven) / msPerDay);

  return diffInDays;
}

export function timeAgo(dateString: string): string {
  const now = new Date();
  const past = new Date(dateString);
  const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds} second${diffInSeconds !== 1 ? "s" : ""} ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes !== 1 ? "s" : ""} ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours !== 1 ? "s" : ""} ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
}
